<style scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
</style>

<template>
<div>
    <Modal
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose">

        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
            <FormItem label="资源名称:" prop="source_name">
                <Input type="text" v-model="formData.source_name"></Input>
            </FormItem>
            <FormItem label="缩略图：" prop="thumb">
                <ImgUpload ref="upImg" :action="actionUrlThumb" :hasUpload="hasUpload" :num="num" @setThumbUrl="setThumbUrlthumb"></ImgUpload>
                <span class="simple-size">大小： 480 * 272</span>
            </FormItem>
            <FormItem label="简单描述:" prop="des">
                <Input type="text" v-model="formData.des"></Input>
            </FormItem>
            <FormItem label="单价:" prop="price">
                <Input type="text" v-model="formData.price"></Input>
            </FormItem>
            <FormItem label="单位:" prop="unit">
                <Input type="text" v-model="formData.unit"></Input>
            </FormItem>
            <FormItem label="所属分类" prop="cate_id" >
                <SearchSelect :isMultiple='2' ref="apply_val" :url="searchCateUrl" labelName='cate_name' valName='id' keyword="keyword" @setSelected="setSelectVal($event,'cate_id')"></SearchSelect>
            </FormItem>
            <FormItem label="状态：" prop="status">
                <RadioGroup v-model="formData.status">
                    <Radio label="1">
                        <span>显示</span>
                    </Radio>
                    <Radio label="2">
                        <span>隐藏</span>
                    </Radio>
                </RadioGroup>
            </FormItem>
             <FormItem label="排序:" prop="sort">
                <Input type="text"  v-model="formData.sort"></Input>
            </FormItem>


            <FormItem label="详情:" prop="detail">
                <vue-neditor-wrap v-model="formData.detail" :config="editorConfig" :destroy="false"></vue-neditor-wrap>
            </FormItem>

            <FormItem>
                <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
            </FormItem>
        </Form>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import SearchSelect from '../common/selectList';
import VueNeditorWrap from 'vue-neditor-wrap';
import ImgUpload from "../common/upload";
    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object
        },
        name: "Model3",
        data() {
            return {
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                searchCateUrl: this.config.urlArray.searchSourceCate,
                editorConfig: {
                    // 如果需要上传功能,找后端小伙伴要服务器接口地址
                    serverUrl: this.config.urlArray.uploadCateThumb,
                    // 你的UEditor资源存放的路径,相对于打包后的index.html
                    UEDITOR_HOME_URL: '/neditor/',
                    // 编辑器不自动被内容撑高
                    autoHeightEnabled: false,
                    // 初始容器高度
                    initialFrameHeight: 240,
                    // 初始容器宽度
                    initialFrameWidth: '100%',
                    // 关闭自动保存
                    enableAutoSave: false
                },
                formData: {//表单数据
                    source_name: '',
                    sort: '100',
                    thumb: '',
                    cate_id: '',
                    des:'',
                    price:'',
                    unit:'',
                    status: '1',
                    detail:''
                },
                actionUrlThumb: this.config.urlArray.sourceThumb, //上传图片接口
                num: 1, //图片上传数量
                hasUpload: [], //已上传图片
                ruleCustom: {//验证
                    source_name: [
                        {required: true, message: '资源名称不能为空', trigger: 'blur' },
                    ],
                    cate_id: [
                        {required: true, message: '分类必须选择', trigger: 'blur' },
                    ],
                    des: [
                        {required: true, message: '简单描述不能为空', trigger: 'blur' },
                    ],
                    price: [
                        {required: true, message: '单价不能为空', trigger: 'blur' },
                    ],
                    unit: [
                        {required: true, message: '单位不能为空', trigger: 'blur' },
                    ],
                    status: [
                        {required: true, message: '状态不能为空', trigger: 'change' },
                    ],
                    thumb: [
                        { required: true, message: "缩略图片必须上传", trigger: "blur" },
                    ],
                    detail: [
                        { required: true, message: "详情必须填写", trigger: "blur" },
                    ],
                    sort: [
                        {required: true, message: '排序不能为空', trigger: 'blur' },
                        { type: 'string', pattern: /^[0-9]\d*$/i, message:'排序必须为不小于零的整数', trigger:'blur'},
                    ],
                },
            }
        },
        components: {
            SearchSelect,
            ImgUpload,
            VueNeditorWrap
        },
        methods: {
            setThumbUrlthumb(url) { //获取图片上传后的路径   商品封面图
                this.formData.thumb = url;
            },
            openOrClose(value) {
                if(value === true) {
                    if(this.type == 2){//编辑表单时，给表单赋值
                        this.formData.source_name = this.editFormData.source_name.toString();
                        this.formData.sort = this.editFormData.sort.toString();
                        this.formData.des = this.editFormData.des;
                        this.formData.detail = this.editFormData.detail;
                        this.formData.status = this.editFormData.status.toString();
                        this.formData.cate_id = this.editFormData.cate_id.toString();
                        this.formData.price = this.editFormData.price.toString();
                        this.formData.unit = this.editFormData.unit.toString();
                        this.formData.thumb = this.editFormData.thumb
                        let hasUpload = [{
                            status:'finished',
                            response:{data:{path:this.editFormData.thumb}}
                        }]
                        this.$refs.upImg.setHasUpload(hasUpload)//为上传组件付默认值

                        setTimeout(() => {
                            this.$refs.apply_val.setDefVal(Number(this.formData.cate_id));
                        }, 500);

                    }
                    this.title = this.type == 1?'添加资源':'编辑资源'
                } else { //关闭弹框后要做的处理
                    this.$refs.upImg.clearImg()//清除已上传的图片
                    this.$refs.apply_val.clearVal();
                    this.resetForm();//重置表单
                }
            },
            subData(name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;

                        if (this.type == 2) {
                            this.formData.id = this.editFormData.id
                        }

                        this.axios.post(this.config.urlArray.sourceStore, this.formData).then((result) => {
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{this.disabled = false; })

                        }).catch((err) => {
                            common.msg('error','提交失败',()=>{this.disabled = false;})
                        });

                    }
                })
            },
            setSelectVal(data,key){
                this.formData[key] = data.toString()
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.$refs.upImg.clearImg()//清除已上传的图片
                this.$refs.apply_val.clearVal();
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                if(this.type == 2){
                    delete this.formData.id
                }
            }
        }
    }
</script>
